import React, { useState, useEffect } from 'react';

function Countdown({ ...props }) {
  const { setPage } = props;
  const [count, setCount] = useState(3);

  useEffect(() => {
    if (count > 0) {
      const timerId = setTimeout(() => setCount(count - 1), 1000);
      return () => clearTimeout(timerId);
    } else if (count === 0) {
      const timerId = setTimeout(() => {
        setPage('timer-tap');
        setCount(null);
      }, 1000);
      return () => clearTimeout(timerId);
    }
  }, [count, setPage]);

  return (
    <>
      <div style={{ position: 'absolute', top: (count === 0 ? 200 : 0), left: 0, width: '100%', height: '100%', fontSize: (count === 0 ? '115.29px' : '450px'), fontWeight: 'bold', textAlign: 'center', fontFamily: 'Speedee Bold', background: count % 2 === 0 ? '#FFFFFF' : '#FFBC0D', color: count % 2 === 0 ? '#FFBC0D' : '#FFFFFF' }}>
        {count > 0 ? count : (count === 0 ? 'Tap!' : null)}
      </div>
      { count > 0 && (
        <div style={{ position: 'absolute', bottom: '150px', left: 0, width: '100%', textAlign: 'center', fontSize: 60, lineHeight: '95%', letterSpacing: '-0.03em', fontFamily: 'Speedee Bold', color: '#2D2D2D' }}>
          Get ready
        </div>
      ) }
    </>
  );
}

export default Countdown;